module.exports = {"360302001":"东大街街道","360302002":"凤凰街街道","360302003":"八一街街道","360302004":"后埠街街道","360302005":"丹江街街道","360302006":"白源街街道","360302100":"安源镇","360302101":"高坑镇","360302102":"五陂镇","360302103":"青山镇","360302400":"五陂下垦殖场","360302401":"城郊管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360302.json
// module id = 1162
// module chunks = 0